module.exports = __webpack_public_path__ + "img/food-dinner-dish-plate-fork.a045ebb9.svg";